import { information } from './modal-option';
import { LangOffline } from '../../../localization/webmodule-common/other/ui/offline-lang';

export async function offline() {
  await information(LangOffline.operationFailed(), LangOffline.systemOffline());
}
